const touristInvitationScores = [
    { haveInvitation: true, score: 20 },
    { haveInvitation: false, score: 0 },
];

export default touristInvitationScores;
